import React, {FC} from 'react';
import styled from 'styled-components';
import {ColorItemDesktop} from '../../FilterContent/Color/ColorItemDesktop';
import {FilterColor as Color} from '../../FilterContent/Color/types';
import {FilterDropdown} from '../FilterDropdown';
interface Props {
  activeColorIds: Array<string>;
  colors: Array<Color>;
  label: string;
  onColorClick: (colorId: string) => void;
  onFilterReset: () => void;
  onOpen?: () => void;
  onClose?: () => void;
}

export const FilterDropdownColor: FC<Props> = ({
  activeColorIds,
  colors,
  label,
  onColorClick,
  onFilterReset,
  onOpen,
  onClose,
}) => {
  return (
    <FilterDropdown
      dataTestId="filterDropdownColor"
      activeCount={activeColorIds.length}
      label={label}
      onReset={onFilterReset}
      onClose={onClose}
      onOpen={onOpen}
      filterContent={
        <Wrapper data-testid="filterDropdownSectionColor">
          {colors.map(color => (
            <FilterDropdownColorItem
              color={color}
              key={`filter-flyout-color-${color.id}`}
              labelPosition="right"
              onClick={onColorClick}
              selected={activeColorIds.includes(`${color.id}`)}
              size="small"
              showProductCount={color.productCount > 0}
            />
          ))}
        </Wrapper>
      }
    />
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const FilterDropdownColorItem = styled(ColorItemDesktop)`
  display: flex;
  flex: 1 1 50%;
  align-items: center;
  max-width: 50%;
  margin-bottom: 12px;
`;
